// @flow
/** @jsx jsx */

import Formatic from 'formatic';
import { jsx, css } from '@emotion/core';

import { Colors } from '@zapier/theme';

const Styles = {
  root: css({
    '& .formatic .fm-field input': {
      backgroundColor: 'inherit',
      ':read-only, :read-only:hover': {
        backgroundColor: 'inherit',
      },
    },
    '& .formatic .fm-field textarea': {
      backgroundColor: 'inherit',
      ':disabled, :disabled:hover': {
        backgroundColor: Colors.storm,
        cursor: 'not-allowed',
      },
    },
    '& .formatic .fm-field div.pretty-text-box': {
      backgroundColor: 'inherit',
      '&.readonly': {
        backgroundColor: Colors.storm,
      },
    },
    '& .formatic .fm-field .fm-singlelinestring': {
      backgroundColor: 'inherit',
      ':hover': {
        backgroundColor: 'inherit',
      },
    },
    '& .formatic .fm-field textarea.fm-string': {
      backgroundColor: 'inherit',
      ':hover': {
        backgroundColor: 'inherit',
      },
    },
  }),
};

type Props = {
  className?: string,
};

const FlowForm = (props: Props) => {
  const className = `flowform ${props.className || ''}`.trim();
  return (
    <div className={className} css={Styles.root}>
      <Formatic {...props} />
    </div>
  );
};

export default FlowForm;
